// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__5T4lQ","hideSidebar":"Logo_hideSidebar__B1O0L"};